import React from 'react';
import InputField from 'commons/components/FormFields/InputField';

//A specific version of the InputField which only allows numeric input.
function NumberField(props: any) {

    function allowNumbers(event: KeyboardEvent) {
        const asciiCode = event.charCode;
        if (asciiCode > 31 && (asciiCode < 48 || asciiCode > 57)) {
            event.preventDefault();
        }
    }
    
    return (
        <InputField {...props} onKeyPress={allowNumbers} />
    );

}

export default NumberField;